import getCanPlayLegacyDash from "selectors/device/getCanPlayLegacyDash";

export default getCanPlayLegacyDash;
